var _defs, _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialEvents(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 85 66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_0_576bff0950399a764db50fe49c68b9b8a33f0cadfdea5ac21839729d1358eae0",
    x1: 24.064,
    y1: 44.948,
    x2: 60.94,
    y2: 44.948,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#7a0399"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b10372"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_576bff0950399a764db50fe49c68b9b8a33f0cadfdea5ac21839729d1358eae0",
    x1: 35.754,
    y1: 43.552,
    x2: 49.251,
    y2: 43.552,
    xlinkHref: "#SVGID_0_576bff0950399a764db50fe49c68b9b8a33f0cadfdea5ac21839729d1358eae0"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_576bff0950399a764db50fe49c68b9b8a33f0cadfdea5ac21839729d1358eae0",
    x1: 28.238,
    y1: 36.329,
    x2: 37.211,
    y2: 36.329,
    xlinkHref: "#SVGID_0_576bff0950399a764db50fe49c68b9b8a33f0cadfdea5ac21839729d1358eae0"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M42.541 32.686l-.076.079-.002-.002c-4.066-4.066-10.658-5.32-14.724-1.254-4.066 4.066-4.066 10.658 0 14.724l14.724 14.724 14.724-14.724-.002-.002.079-.076c4.066-4.066 4.066-10.658 0-14.724-4.066-4.066-10.658-2.812-14.724 1.254z",
    stroke: "url(#SVGID_0_576bff0950399a764db50fe49c68b9b8a33f0cadfdea5ac21839729d1358eae0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M48.062 59.54h16.753V26.739l-7.617-5.19-8.661-5.899-6.038-4.11-6.038 4.11-8.656 5.899-7.618 5.19V59.54h16.676"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M68.392 22.679v6.497l-3.575-2.437-7.618-5.19-8.661-5.899-6.038-4.112-6.038 4.112-8.656 5.899-7.618 5.19-3.58 2.437v-6.497l10.319-7.029L42.5 5.041 58.073 15.65l10.319 7.029z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_main",
    d: "M52.037 11.538V5.814h5.915v9.675"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    stroke: "url(#SVGID_1_576bff0950399a764db50fe49c68b9b8a33f0cadfdea5ac21839729d1358eae0)",
    d: "M48.626 41.161h-3.733v-3.733h-4.782v3.733h-3.732v4.782h3.732v3.733h4.782v-3.733h3.733v-4.782z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "MI_4L_gradient",
    d: "M36.586 32.994s-6.6.1-7.724 6.67",
    stroke: "url(#SVGID_2_576bff0950399a764db50fe49c68b9b8a33f0cadfdea5ac21839729d1358eae0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialEvents);
export default __webpack_public_path__ + "static/media/socialEvents.1624f93cec5e76e767277ede2f593185.svg";
export { ForwardRef as ReactComponent };